import {createBrowserHistory, createMemoryHistory} from 'history';

const history = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? /* istanbul ignore next */ createBrowserHistory() : createMemoryHistory();
export default history;